import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

export const DatosEditablesLatexProceso = {
    GtosDeCompraDeMP: { rowName: '(+) Gtos de compra de MP', ...DefaultMonthsColumns },
    SKIM: { rowName: '(-) SKIM', ...DefaultMonthsColumns },
    CoaguloLavadoDePilasCentrifugas: { rowName: '(-) Coágulo lavado de pilas/centrifugas', ...DefaultMonthsColumns },
    CoaguloDeTrampas: { rowName: '(-) Coágulo de Trampas', ...DefaultMonthsColumns },
    CostoDeProcesoCentrifugado: { rowName: 'Costo de proceso centrifugado', ...DefaultMonthsColumns },
    InvInicialDePP: { rowName: '(+) Inv. Inicial de PP', ...DefaultMonthsColumns },
    LatexDeMaquilaXFormula: { rowName: '(+) Latex de maquila x formula', ...DefaultMonthsColumns },
    Perdida1Porciento: { rowName: '(-) Perdida (1%)', ...DefaultMonthsColumns },
    CoagulosCentrifugado: { rowName: '(-) Coágulos centrifugado', ...DefaultMonthsColumns },
    ComprasDePT: { rowName: '(+) Compras de PT', ...DefaultMonthsColumns }, 
};

export const DatosCalculadosLatexProceso = {
    CostoVtaDelMes: { rowName: '(-) Costo Vta. Del Mes', ...DefaultMonthsColumns },
    InvFinalDePT: { rowName: '(=) Inventario Final de PT', ...DefaultMonthsColumns },
    ProdTerminFinal: { rowName: '(=) Prod. Termin. Final', ...DefaultMonthsColumns },
};

export const LatexProcesoData = {
    ...DatosEditablesLatexProceso,
    ...DatosCalculadosLatexProceso,
};
